import { LitElement } from 'lit-element';

export default class SimpleLitElement extends LitElement {
    createRenderRoot() {
        return this;
    }

    firstUpdated() {
        if (!this.loaded) {
            this.loaded = true;
        }
    }
}
